export const iconFontAwesomeAstronomyBinoculars = (
	<i className="fa-solid fa-binoculars"></i>
);
